





















































import Vue from 'vue'

export default Vue.extend({
  name: 'CategoriesTable',
  props: {
    tableData: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    paymentByCategoryTable: [],
    col4Sum: 0,
    col5Sum: 0,
    col6Sum: 0,
    col7Sum: 0
  }),
  watch: {
    tableData(val) {
      if (val) {
        this.paymentByCategoryTable = val.paymentByCategoryTable
        this.col4Sum = val.col4Sum
        this.col5Sum = val.col5Sum
        this.col6Sum = val.col6Sum
        this.col7Sum = val.col7Sum
      }
    }
  }
})
